
//#region fingerprintjs
function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${cname}=${cvalue}; expires=${d.toUTCString()}; path=/`;
}

function loadFingerprintJS() {
  // https://github.com/fingerprintjs/fingerprintjs

  // Initialize the agent at application startup.
  // If you're using an ad blocker or Brave/Firefox, this import will not work.
  // Please use the NPM package instead: https://t.ly/ORyXk

  // const url = "https://openfpcdn.io/fingerprintjs/v4";
  const url = "https://cdn.120365.org/?proxyId=fingerprintjs";
  const fpPromise = import(url).then(
    (FingerprintJS) => FingerprintJS.load()
  );

  // Get the visitor identifier when you need it.
  fpPromise
    .then((fp) => fp.get())
    .then((result) => {
      // This is the visitor identifier:
      const visitorId = result.visitorId;
      console.log("fingerprint", visitorId);
      localStorage.fingerprint = visitorId;
      setCookie("fingerprint", visitorId, 365);
    });
}

loadFingerprintJS();
//#endregion fingerprintjs


//#region Matomo Tag Manager
function loadMatomoTagManager() {
  var _mtm = window._mtm = window._mtm || [];
  _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
  (function() {
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='https://matomo.120365.org/js/container_LuPKkXHw.js'; s.parentNode.insertBefore(g,s);
  })();
}

loadMatomoTagManager();
//#endregion Matomo Tag Manager


